import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const VivaEngageAppInsights = () =>
  import(/* webpackChunkName: "4-feat-vivaengageappinsights" */ './VivaEngageAppInsights');
export default lazyLoadOnRender({ loader: VivaEngageAppInsights });
